import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import ApiService from '../../common/services/ApiService';
import {
  DECLINE_REFERRAL_BEGIN,
  DECLINE_REFERRAL_SUCCESS,
  DECLINE_REFERRAL_FAILURE,
  DECLINE_REFERRAL_DISMISS_ERROR,
} from './constants';

export function declineReferral(referralUUID, args) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: DECLINE_REFERRAL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      ApiService.declineReferral(referralUUID, args).then(
        (res) => {
          dispatch({
            type: DECLINE_REFERRAL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: DECLINE_REFERRAL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeclineReferralError() {
  return {
    type: DECLINE_REFERRAL_DISMISS_ERROR,
  };
}

export function useDeclineReferral() {
  const dispatch = useDispatch();

  const { declineReferralPending, declineReferralError } = useSelector(
    state => ({
      declineReferralPending: state.referral.declineReferralPending,
      declineReferralError: state.referral.declineReferralError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((referralUUID, args) => {
    return dispatch(declineReferral(referralUUID, args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissDeclineReferralError());
  }, [dispatch]);

  return {
    declineReferral: boundAction,
    declineReferralPending,
    declineReferralError,
    dismissDeclineReferralError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DECLINE_REFERRAL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        declineReferralPending: true,
        declineReferralError: null,
      };

    case DECLINE_REFERRAL_SUCCESS:
      // The request is success
      return {
        ...state,
        declineReferralPending: false,
        declineReferralError: null,
      };

    case DECLINE_REFERRAL_FAILURE:
      // The request is failed
      return {
        ...state,
        declineReferralPending: false,
        declineReferralError: action.data.error,
      };

    case DECLINE_REFERRAL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        declineReferralError: null,
      };

    default:
      return state;
  }
}
